import { ExpressionRuleEditor } from "../ExpressionRuleEditor";
import { GroupedBracketedDiv } from "../Logic/AndGroupEditor";
import { ExpressionPiece } from "../../Builder/ExpressionStyles";
import React from "react";
import { DateGetTodayExpression } from "../../../rule-engine-core/Expressions/Expressions/Date/DateGetTodayExpression";

export class DateGetTodayExpressionEditor extends ExpressionRuleEditor<DateGetTodayExpression> {
    render() {
        return (
            <GroupedBracketedDiv issue={this.ruleData!.getValidationIssues()[0]}>
                <ExpressionPiece>Get Today</ExpressionPiece>
            </GroupedBracketedDiv>
        );
    }
}
